"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var themes_1 = require("../../themes/");
var Box_1 = require("../Box");
var Text_1 = require("../Text");
var Icon_1 = require("../Icon");
var icons_1 = require("../../icons");
/** @component */
exports.Notification = function (props) {
    var type = props.type, message = props.message, IconProp = props.icon, borderColor = props.borderColor, gap = props.gap, pad = props.pad, textSize = props.textSize, align = props.align, onClose = props.onClose, rest = tslib_1.__rest(props, ["type", "message", "icon", "borderColor", "gap", "pad", "textSize", "align", "onClose"]);
    var displayColor;
    var DisplayIcon;
    switch (type) {
        case 'success':
            DisplayIcon = (react_1.default.createElement(Icon_1.Icon, { fill: themes_1.colors['status-ok'], stroke: themes_1.colors['status-ok'], id: "success-icon", icon: icons_1.TickCircle, css: { height: '25px', width: '25px', overflow: 'visible' } }));
            displayColor = 'status-ok';
            break;
        case 'error':
            DisplayIcon = (react_1.default.createElement(Icon_1.Icon, { fill: themes_1.colors['status-error'], stroke: themes_1.colors['status-error'], id: "error-icon", icon: icons_1.Invalid, css: { height: '25px', width: '25px', overflow: 'visible' } }));
            displayColor = 'status-error';
            break;
        case 'warning':
            DisplayIcon = (react_1.default.createElement(Icon_1.Icon, { fill: themes_1.colors.brandOrange, stroke: themes_1.colors.brandOrange, id: "warning-icon", icon: icons_1.Invalid, css: { height: '25px', width: '25px', overflow: 'visible' } }));
            displayColor = themes_1.colors['grey-2'];
            break;
        case 'info':
            DisplayIcon = (react_1.default.createElement(Icon_1.Icon, { fill: themes_1.colors.brand.light, stroke: themes_1.colors.brand.light, id: "info-icon", icon: icons_1.Info, css: { height: '25px', width: '25px', overflow: 'visible' } }));
            displayColor = themes_1.colors['grey-2'];
            break;
        case 'custom':
            DisplayIcon = IconProp;
            displayColor = borderColor;
            break;
        default:
            break;
    }
    return (react_1.default.createElement(Box_1.Box, tslib_1.__assign({ pad: pad ? pad : { horizontal: 'large', vertical: 'medium' }, border: { color: displayColor, side: 'all' }, round: "4px", direction: "row", align: align ? align : 'center', gap: gap ? gap : 'small' }, rest),
        DisplayIcon ? react_1.default.createElement(Box_1.Box, null, DisplayIcon) : undefined,
        react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Box_1.Box, { width: "100%", direction: "column" },
                Array.isArray(message)
                    ? Object(message).map(function (value, index) {
                        return (react_1.default.createElement(Text_1.Text, { key: index, tag: "p", size: textSize ? textSize : 'xsmall' }, value));
                    })
                    : undefined,
                typeof message === 'string' ? (react_1.default.createElement(Text_1.Text, { tag: "p", size: textSize ? textSize : 'xsmall' }, message)) : (undefined),
                !Array.isArray(message) && typeof message !== 'string' ? (react_1.default.createElement(Text_1.Text, { tag: "div", size: textSize ? textSize : 'xsmall' }, message)) : (undefined)),
            onClose && (react_1.default.createElement(Box_1.Box, { margin: { left: 'xsmall' }, flex: false, width: "" + themes_1.spacing(16).large },
                react_1.default.createElement(Icon_1.IconButton, { label: "close notification", onClick: onClose, iconProps: {
                        id: 'close_notification',
                        icon: icons_1.Clear,
                        fill: themes_1.colors['grey-9'],
                        width: themes_1.spacing(16).medium,
                        height: themes_1.spacing(16).medium
                    } }))))));
};
//# sourceMappingURL=Notification.js.map